var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React from 'react';
import { IndexRoute, Route } from 'react-router';
import App from "./App/App";
import Activitylog from "./Activitylog/Activitylog";
import { trackPage } from "./App/GoogleAnalytics";
import Configure2fa from "./Auth2fa/Configure2fa";
import EditTranslations from "./I18N/EditTranslations";
import blankState from "./Library/helpers/blankState";
import Library from "./Library/Library";
import LibraryMap from "./Library/LibraryMap";
import { MetadataExtractionDashboard } from "./MetadataExtraction/MetadataExtractionDashboard";
import { IXSuggestions } from "./MetadataExtraction/SuggestionsContainer";
import EditPage from "./Pages/EditPage";
import NewPage from "./Pages/NewPage";
import Pages from "./Pages/Pages";
import PageView from "./Pages/PageView";
import EditRelationType from "./RelationTypes/EditRelationType";
import NewRelationType from "./RelationTypes/NewRelationType";
import OneUpReview from "./Review/OneUpReview";
import SemanticSearchResultsView from "./SemanticSearch/SemanticSearchResultsView";
import {
PreserveSettings,
AccountSettings,
CollectionSettings,
Customisation,
CustomUploads,
EntityTypesList,
FiltersForm,
LanguageList,
NavlinksSettings,
RelationTypesList,
Settings,
ThesauriList,
TranslationsList,
Dashboard } from "./Settings";

import EditTemplate from "./Templates/EditTemplate";
import NewTemplate from "./Templates/NewTemplate";
import EditThesauri from "./Thesauri/EditThesauri";
import NewThesauri from "./Thesauri/NewThesauri";
import ThesaurusCockpit from "./Thesauri/ThesaurusCockpit";
import Uploads from "./Uploads/UploadsRoute";
import Login from "./Users/Login";
import ResetPassword from "./Users/ResetPassword";
import UnlockAccount from "./Users/UnlockAccount";
import ViewerRoute from "./Viewer/ViewerRoute";
import GeneralError from "./App/ErrorHandling/GeneralError";
import { UserManagement } from "./Users/UserManagement";
import { store } from "./store";
import { LibraryTable } from "./Library/LibraryTable";
import { validateHomePageRoute } from "./utils/routeHelpers";

const onEnter = () => {
  trackPage();
};

const goToLogin = () => {
  window.location.assign('/login');
};
const enterLogin = ({ location }) => {
  if (location.action === 'REPLACE') {
    goToLogin();
  }
};

const needsAuth = (_nxtState, _replace) => {
  if (!store.getState().user.get('_id')) {
    goToLogin();
  }
};

const enterOnLibrary = (_nxtState, _replace) => {
  const state = store.getState();
  if (blankState() && !state.user.get('_id')) {
    goToLogin();
    return () => {};
  }

  trackPage();
  return () => {};
};

const getDefaultLibraryComponent = (defaultLibraryView) => {
  switch (defaultLibraryView) {
    case 'table':
      return {
        component: LibraryTable,
        onEnter: enterOnLibrary
      };
    case 'map':
      return {
        component: LibraryMap,
        onEnter
      };
    case 'cards':
    default:
      return {
        component: Library,
        onEnter: enterOnLibrary
      };}

};

const getPageIndexRoute = (customHomePage) => {
  onEnter();
  const pageId = customHomePage[customHomePage.indexOf('page') + 1];
  const component = (props) => /*#__PURE__*/React.createElement(PageView, _extends({}, props, { params: { sharedId: pageId } }));
  component.requestState = (requestParams) =>
  PageView.requestState(requestParams.set({ sharedId: pageId }));

  return {
    component,
    customHomePageId: pageId
  };
};

const libraryDefaults = (callBack, state, defaultView) => {
  if (state.user.get('_id')) {
    return callBack(null, {
      onEnter: (_nextState, replace) => {
        replace('/library/?q=(includeUnpublished:!t)');
      }
    });
  }

  return callBack(null, getDefaultLibraryComponent(defaultView));
};
const getIndexRoute = (_nextState, callBack) => {
  const state = store.getState();
  const homePageSetting = state.settings.collection.get('home_page') || '';
  const customHomePage = homePageSetting ? homePageSetting.split('/').filter((v) => v) : [];
  const defaultView = state.settings.collection.get('defaultLibraryView');

  if (!validateHomePageRoute(homePageSetting) || customHomePage.length === 0) {
    return libraryDefaults(callBack, state, defaultView);
  }
  return customHomePage.includes('page') ?
  callBack(null, getPageIndexRoute(customHomePage)) :
  callBack(null, {
    onEnter: (_nxtState, replace) => {
      replace(customHomePage.join('/'));
    }
  });
};

const routes = /*#__PURE__*/
_jsx(Route, { getIndexRoute: getIndexRoute }, void 0, /*#__PURE__*/
_jsx(Route, { path: "settings", component: Settings, onEnter: needsAuth }, void 0, /*#__PURE__*/
_jsx(Route, { path: "account", component: AccountSettings }), /*#__PURE__*/
_jsx(Route, { path: "dashboard", component: Dashboard }), /*#__PURE__*/
_jsx(Route, { path: "2fa", component: Configure2fa }), /*#__PURE__*/
_jsx(Route, { path: "collection", component: CollectionSettings }), /*#__PURE__*/
_jsx(Route, { path: "navlinks", component: NavlinksSettings }), /*#__PURE__*/
_jsx(Route, { path: "users", component: UserManagement }), /*#__PURE__*/
_jsx(Route, { path: "preserve", component: PreserveSettings }), /*#__PURE__*/
_jsx(Route, { path: "pages" }, void 0, /*#__PURE__*/
_jsx(IndexRoute, { component: Pages }), /*#__PURE__*/
_jsx(Route, { path: "new", component: NewPage }), /*#__PURE__*/
_jsx(Route, { path: "edit/:sharedId", component: EditPage })), /*#__PURE__*/

_jsx(Route, { path: "templates" }, void 0, /*#__PURE__*/
_jsx(IndexRoute, { component: EntityTypesList }), /*#__PURE__*/
_jsx(Route, { path: "new", component: NewTemplate }), /*#__PURE__*/
_jsx(Route, { path: "edit/:templateId", component: EditTemplate })), /*#__PURE__*/

_jsx(Route, { path: "metadata_extraction", component: MetadataExtractionDashboard }), /*#__PURE__*/
_jsx(Route, { path: "metadata_extraction/suggestions/:propertyName", component: IXSuggestions }), /*#__PURE__*/
_jsx(Route, { path: "connections" }, void 0, /*#__PURE__*/
_jsx(IndexRoute, { component: RelationTypesList }), /*#__PURE__*/
_jsx(Route, { path: "new", component: NewRelationType }), /*#__PURE__*/
_jsx(Route, { path: "edit/:_id", component: EditRelationType })), /*#__PURE__*/

_jsx(Route, { path: "dictionaries" }, void 0, /*#__PURE__*/
_jsx(IndexRoute, { component: ThesauriList }), /*#__PURE__*/
_jsx(Route, { path: "new", component: NewThesauri }), /*#__PURE__*/
_jsx(Route, { path: "edit/:_id", component: EditThesauri }), /*#__PURE__*/
_jsx(Route, { path: "cockpit/:_id", component: ThesaurusCockpit })), /*#__PURE__*/

_jsx(Route, { path: "languages", component: LanguageList }), /*#__PURE__*/
_jsx(Route, { path: "translations" }, void 0, /*#__PURE__*/
_jsx(IndexRoute, { component: TranslationsList }), /*#__PURE__*/
_jsx(Route, { path: "edit/:context", component: EditTranslations })), /*#__PURE__*/

_jsx(Route, { path: "filters", component: FiltersForm }), /*#__PURE__*/
_jsx(Route, { path: "customisation", component: Customisation }), /*#__PURE__*/
_jsx(Route, { path: "custom-uploads", component: CustomUploads }), /*#__PURE__*/
_jsx(Route, { path: "activitylog", component: Activitylog, onEnter: needsAuth })), /*#__PURE__*/

_jsx(Route, { path: "library", component: Library, onEnter: enterOnLibrary }), /*#__PURE__*/
_jsx(Route, { path: "library/map", component: LibraryMap, onEnter: onEnter }), /*#__PURE__*/
_jsx(Route, { path: "library/table", component: LibraryTable, onEnter: enterOnLibrary }), /*#__PURE__*/
_jsx(Route, { path: "review", component: OneUpReview, onEnter: needsAuth }), /*#__PURE__*/
_jsx(Route, { path: "uploads", component: Uploads }), /*#__PURE__*/
_jsx(Route, { path: "login", component: Login, onEnter: enterLogin }), /*#__PURE__*/
_jsx(Route, { path: "setpassword/:key", component: ResetPassword }), /*#__PURE__*/
_jsx(Route, { path: "unlockaccount/:username/:code", component: UnlockAccount }), /*#__PURE__*/
_jsx(Route, { path: "document/:sharedId*", component: ViewerRoute, onEnter: onEnter }), /*#__PURE__*/
_jsx(Route, { path: "entity/:sharedId(/:tabView)", component: ViewerRoute, onEnter: onEnter }), /*#__PURE__*/
_jsx(Route, { path: "page/:sharedId", component: PageView, onEnter: onEnter }), /*#__PURE__*/
_jsx(Route, { path: "page/:sharedId/:slug", component: PageView, onEnter: onEnter }), /*#__PURE__*/
_jsx(Route, {
  path: "semanticsearch/:searchId",
  component: SemanticSearchResultsView,
  onEnter: onEnter }), /*#__PURE__*/

_jsx(Route, { path: "error/:errorCode", component: GeneralError }), /*#__PURE__*/
_jsx(Route, { path: "404", component: GeneralError }));



export { getIndexRoute };

export default /*#__PURE__*/
_jsx(Route, { path: "/", component: App }, void 0,
routes, /*#__PURE__*/
_jsx(Route, { path: ":lang" }, void 0,
routes, /*#__PURE__*/
_jsx(Route, { path: "*", component: GeneralError })), /*#__PURE__*/

_jsx(Route, { path: "*", component: GeneralError }));